import { JsonConvert, JsonConverter, JsonCustomConvert, JsonObject, JsonProperty } from "json2typescript";
import { BaseResponse } from "./base-response";
import { MonitoringFirewall, MonitoringFirewallArrayConverter } from "./monitoring-firewall";
import { Location } from 'src/app/core/models/location';

@JsonConverter
export class MonitoringDetailedLogConverter implements JsonCustomConvert<MonitoringDetailedLog>{
	serialize() { }
	deserialize(data: any): MonitoringDetailedLog {
		const jsonConvert: JsonConvert = new JsonConvert();
		return jsonConvert.deserializeObject(data, MonitoringDetailedLog);
	}
}

@JsonConverter
export class MonitoringDetailedLogArrayConverter implements JsonCustomConvert<Array<MonitoringDetailedLog>>{
	serialize() { }
	deserialize(data: any): Array<MonitoringDetailedLog> {
		const jsonConvert: JsonConvert = new JsonConvert();
		return jsonConvert.deserializeArray(data, MonitoringDetailedLog);
	}
}

@JsonConverter
export class MonitoringDetailedLogListConverter implements JsonCustomConvert<MonitoringDetailedLogList>{
	serialize() { }
	deserialize(data: any): MonitoringDetailedLogList {
		const jsonConvert: JsonConvert = new JsonConvert();
		return jsonConvert.deserializeObject(data, MonitoringDetailedLogList);
	}
}

@JsonObject("MonitoringDetailedLog")
export class MonitoringDetailedLog {
	@JsonProperty("date", Number, true)
	date: string = "";
	@JsonProperty("hostname", String, true)
	hostname: string = "";
	@JsonProperty("ip", String, true)
	ip: string = "";
	@JsonProperty("mac", String, true)
	mac: string = "";
	@JsonProperty("login", Number, true)
	login: number = 0;
	@JsonProperty("dhcp_lease", Number, true)
	dhcp_lease: number = 0;
	@JsonProperty("arp_table", Number, true)
	arp_table: number = 0;
	@JsonProperty("nasid", String, true)
	nasid: string = "";
	@JsonProperty("firewall", MonitoringFirewallArrayConverter, true)
	firewall: Array<MonitoringFirewall> = new Array<MonitoringFirewall>;
	@JsonProperty("vpn", String, true)
	vpn: string = "";
	@JsonProperty("expand", Boolean, true) // create for nested table
	expand: boolean = false;

	_location: string | undefined = "";

	setLocation(locations: Array<Location>) {
		this._location = locations.find(l => l.nasid === this.nasid) ? locations.find(l => l.nasid === this.nasid)?.name : this.nasid || "";
	}
}

@JsonObject("MonitoringDetailedLogList")
export class MonitoringDetailedLogList {
	@JsonProperty("count", Number, true)
	count: number = 0;
	@JsonProperty("data", MonitoringDetailedLogArrayConverter, true)
	data: Array<MonitoringDetailedLog> = new Array<MonitoringDetailedLog>();

	setLocations(locations: Array<Location>) {
		this.data.forEach(d => {
			d.setLocation(locations);
		});
	}
}

@JsonObject("MonitoringDetailedLogData")
export class MonitoringDetailedLogData extends BaseResponse {
	@JsonProperty("data", MonitoringDetailedLogConverter, true)
	data: MonitoringDetailedLog = new MonitoringDetailedLog();
}

@JsonObject("MonitoringDetailedLogListData")
export class MonitoringDetailedLogListData extends BaseResponse {
	@JsonProperty("data", MonitoringDetailedLogArrayConverter, true)
	data: Array<MonitoringDetailedLog> = new Array<MonitoringDetailedLog>();

	setLocations(locations: Array<Location>) {
		this.data.forEach(d => {
			d.setLocation(locations);
		});
	}

}